/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipMetadataCampaignsQueryResponse, AuditReportsGetGipMetadataCampaignsQueryParams, AuditReportsGetGipMetadataCampaigns401, AuditReportsGetGipMetadataCampaigns403 } from "../models/AuditReportsGetGipMetadataCampaigns";

export function getAuditReportsGetGipMetadataCampaignsUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip/metadata/campaigns` as const }
  return res
}

/**
 * @summary Return GIP campaigns for stations in a range
 * {@link /audit-reports/v1/reports/gip/metadata/campaigns}
 */
export async function auditReportsGetGipMetadataCampaigns(params: AuditReportsGetGipMetadataCampaignsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetGipMetadataCampaignsQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataCampaigns401 | AuditReportsGetGipMetadataCampaigns403>, unknown>({ method : "GET", url : getAuditReportsGetGipMetadataCampaignsUrl().url.toString(), params, ... requestConfig })
  return res.data
}